<template>
  <div>
    <b-row class="border-bottom mb-2">
      <b-col>
        <h3 class="mb-0">
          Object Properties
        </h3>
        <small class="text-muted">
          Add properties that defines the object.
        </small>
      </b-col>
    </b-row>
    <div>
      <b-form
        ref="form"
        :style="{height: trHeight}"
        class="repeater-form"
        style="overflow: visible"
        @submit.prevent="repeateAgain"
      >

        <!-- Row Loop -->
        <b-row
          v-for="(item, index) in items"
          :id="item.id"
          :key="item.id"
          ref="row"
        >

          <!-- Item Name -->
          <b-col md="4">
            <b-form-group
              label="Property"
              label-for="item-name"
            >
              <v-select
                label="name"
                taggable
                push-tags
                :options="objectProperties"
                @input="setSelected"
              />
            </b-form-group>
          </b-col>

          <!-- Property Value -->
          <b-col
            v-if="newObject.properties[index]"
            md="2"
          >
            <b-form-group
              label="Value"
              label-for="Value"
            >
              <b-form-input
                id="Property Value"
                v-model="newObject.properties[index].value"
                type="text"
                placeholder="Value"
              />
            </b-form-group>
          </b-col>

          <!-- Property -->
          <b-col
            v-if="newObject.properties[index]"
            md="2"
          >
            <b-form-group
              label="Unit"
              label-for="Unit"
            >
              <b-form-input
                id="Unit"
                v-model="newObject.properties[index].unit"
                type="text"
                placeholder="m / cm / kg / C"
              />
            </b-form-group>
          </b-col>

          <!-- Remove Button -->
          <b-col
            lg="2"
            md="3"
            class="mb-50"
          >
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-danger"
              class="mt-0 mt-md-2"
              @click="removeItem(index)"
            >
              <feather-icon
                icon="XIcon"
                class="mr-25"
              />
              <span>Delete</span>
            </b-button>
          </b-col>
          <b-col cols="12">
            <hr>
          </b-col>
        </b-row>

      </b-form>
    </div>
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="repeateAgain"
    >
      <feather-icon
        icon="PlusIcon"
        class="mr-25"
      />
      <span>Add Property</span>
    </b-button>

  </div>

</template>

<script>
import {
  BForm, BFormGroup, BFormInput, BRow, BCol, BButton,
} from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

export default {
  components: {
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    vSelect,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  props: {
    newObject: {
      type: Object,
      required: true,
    },
    objectProperties: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      items: [],
      nextTodoId: 2,
    }
  },
  watch: {
    newObject: {
      deep: true,
      handler(newVal) {
        this.newObject = newVal
      },
    },
  },
  mounted() {
    this.initTrHeight()
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    repeateAgain() {
      this.items.push({
        id: this.nextTodoId += this.nextTodoId,
      })
      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    removeItem(index) {
      this.items.splice(index, 1)
      this.newObject.properties.splice(index, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
    setSelected(value) {
      if (value.id === undefined) {
        this.newObject.properties.push({
          name: value,
          value: '',
        })
      } else {
        this.newObject.properties.push({
          id: value.id,
          name: value.name,
          value: '',
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.repeater-form {

  transition: .35s height;
}
</style>
